import React from 'react';
import { Select } from 'antd';

type InlineInputProps = {
  value: string[];
  onChange: (value: string[]) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  placeholder?: string;
  status?: '' | 'warning' | 'error';
};

const InlineInput: React.FC<InlineInputProps> = ({
  value,
  onChange,
  style,
  disabled,
  placeholder,
  status,
}) => {
  return (
    <Select
      mode={'tags'}
      placeholder={placeholder || ''}
      style={style}
      onChange={onChange}
      tokenSeparators={[',']}
      value={value}
      options={[]}
      suffixIcon={null}
      disabled={disabled}
      dropdownRender={() => null}
      dropdownStyle={{ display: 'none' }}
      status={status}
    />
  );
};

export default InlineInput;
